import React, { useState } from 'react';
import './XhsPublishTest.css';
import './rednote-app-launcher.js';

const DEFAULT_IMAGE = 'https://picsum.photos/800/800';

function getLauncher() {
  return window.RednoteAppLauncher;
}

function XhsPublishTest() {
  const [title, setTitle] = useState('这是标题内容');
  const [content, setContent] = useState('这是正文内容');
  const [images, setImages] = useState(DEFAULT_IMAGE);
  const [jumpUrl, setJumpUrl] = useState('');
  const [statusMessage, setStatusMessage] = useState('');

  const buildShareInfo = () => {
    const imageList = images
      .split(/[\n,]/)
      .map((url) => url.trim())
      .filter((url) => /^https?:\/\//i.test(url));

    return {
      type: 'normal',
      title: title.trim(),
      content: content.trim(),
      images: imageList,
    };
  };

  const getPublishErrorMessage = (shareInfo) => {
    const launcher = getLauncher();
    const env = launcher.getEnvironment();

    if (!env.isMobile) {
      return '请在手机浏览器中打开此页面后再跳转';
    }

    if (!shareInfo.images.length) {
      return '请至少填写一张公网可访问的图片地址（http/https）';
    }

    if (!launcher.canOpenPublish(shareInfo)) {
      return '当前环境不支持跳转，请检查图片地址是否有效';
    }

    return '';
  };

  const generateJumpUrl = () => {
    const launcher = getLauncher();
    const shareInfo = buildShareInfo();
    const errorMessage = getPublishErrorMessage(shareInfo);

    if (errorMessage) {
      setJumpUrl('');
      setStatusMessage(errorMessage);
      return '';
    }

    const route = launcher.buildPublishRoute(shareInfo);
    const url = route ? route.url : '';
    setJumpUrl(url);
    setStatusMessage(url ? `已生成 ${route.platform} 跳转链接` : '生成跳转链接失败');
    return url;
  };

  const handleJump = () => {
    const launcher = getLauncher();
    const shareInfo = buildShareInfo();
    const errorMessage = getPublishErrorMessage(shareInfo);

    if (errorMessage) {
      setStatusMessage(errorMessage);
      alert(errorMessage);
      return;
    }

    const route = launcher.buildPublishRoute(shareInfo);
    if (route) {
      setJumpUrl(route.url);
    }

    const result = launcher.openPublish(shareInfo);

    if (!result.ok) {
      if (result.reason === 'in_app_browser') {
        setStatusMessage('当前在微信/QQ 等内置浏览器中，请按提示在系统浏览器打开');
        return;
      }

      setStatusMessage('跳转失败，请检查图片地址或更换浏览器重试');
      alert('跳转失败，请检查图片地址或更换浏览器重试');
      return;
    }

    setStatusMessage(`正在跳转（${result.route.platform}）...`);
  };

  const handleCopyUrl = () => {
    const url = generateJumpUrl();
    if (!url) {
      return;
    }

    const copyText = (text) => {
      if (navigator.clipboard && window.isSecureContext) {
        return navigator.clipboard.writeText(text);
      }

      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();

      try {
        const copied = document.execCommand('copy');
        if (!copied) {
          throw new Error('浏览器不支持自动复制');
        }
      } finally {
        document.body.removeChild(textarea);
      }

      return Promise.resolve();
    };

    copyText(url).then(() => {
      alert('跳转链接已复制到剪贴板');
    }).catch((err) => {
      alert('复制失败：' + err.message);
    });
  };

  return (
    <div className="xhs-publish-test-container">
      <div className="xhs-publish-test-card">
        <h1 className="xhs-publish-test-title">小红书发布页面跳转测试</h1>
        <p className="xhs-publish-test-description">
          基于 rednote-app-launcher，通过 share_sdk / post_new_note 协议传递标题和正文
        </p>

        <div className="xhs-publish-test-form">
          <div className="form-group">
            <label htmlFor="title">标题内容</label>
            <input
              id="title"
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="请输入标题"
              className="form-input"
            />
          </div>

          <div className="form-group">
            <label htmlFor="content">正文内容</label>
            <textarea
              id="content"
              value={content}
              onChange={(e) => setContent(e.target.value)}
              placeholder="请输入正文内容"
              className="form-textarea"
              rows="6"
            />
          </div>

          <div className="form-group">
            <label htmlFor="images">图片地址（必填，多个用逗号或换行分隔）</label>
            <textarea
              id="images"
              value={images}
              onChange={(e) => setImages(e.target.value)}
              placeholder="https://example.com/image.jpg"
              className="form-textarea"
              rows="3"
            />
          </div>

          {statusMessage && (
            <div className="status-message">{statusMessage}</div>
          )}

          <div className="form-group">
            <label>生成的跳转链接</label>
            <div className="url-display">
              {jumpUrl || '点击按钮生成跳转链接'}
            </div>
          </div>

          <div className="button-group">
            <button
              onClick={handleJump}
              className="btn btn-primary"
            >
              跳转到小红书发布页
            </button>
            <button
              onClick={handleCopyUrl}
              className="btn btn-secondary"
            >
              复制跳转链接
            </button>
            <button
              onClick={generateJumpUrl}
              className="btn btn-secondary"
            >
              生成链接预览
            </button>
          </div>
        </div>

        <div className="xhs-publish-test-info">
          <h3>使用说明</h3>
          <ul>
            <li>填写标题、正文，并至少提供一张公网图片 URL</li>
            <li>Android / 鸿蒙：使用 <code>xhsdiscover://share_sdk</code> 传递 base64 编码的笔记数据</li>
            <li>iOS：通过 <code>oia.xiaohongshu.com</code> 中转 <code>post_new_note</code> 协议传递标题正文</li>
            <li>在微信/QQ 内置浏览器中会提示「在系统浏览器打开」</li>
          </ul>

          <h3>注意事项</h3>
          <ul>
            <li>必须在手机浏览器中测试，PC 端无法唤起 App</li>
            <li>图片必须是公网可访问的 http/https 地址</li>
            <li>仅填标题正文不带图片时，当前方案无法跳转</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default XhsPublishTest;
